import React from 'react';
import './App.scss';
import PanelHost from "./components/PanelHost";

const App: React.FC = () => {
    return (
        <div className="App">
            <PanelHost/>
        </div>
    );
};

export default App;
